const state = {
  /* user */
  userAllInfo: {}, // 用户所有信息
  dictTree: {},
  token: '',
  privileges: [], // 权限列表
  isRoot: false,
  /* serverMap */
  serverMap: [],
  /* 开通 */
  shoppingCart: [], // 选中的要开通的产品
  payList: [], // 选中的要开通缴费的申请
  /* 充值 */
  invoiceList: [], // 选择的需要开发票的记录
  invoiceRecord: [],
  invoiceMoney: 0, // 开票总金额
  /**操作 */
  currentOrder: {}, // 当前操作的订单
  currentStore: {}, // 当前选中的要转出的门店
  selectProduct: {}, // 首页选择的产品类型
}

export default state
